import { LINKS } from "@silo/types";
import { cn } from "../../utils/class-names";
import { DescriptionExternalLink } from "../description";
import { KeyValueList } from "../key-value-list";
import {
  getAprDescription,
  getAprLabel,
  getUtilizationClassName,
} from "./utils";
import {
  UtilizationState,
  AprState as AprStateType,
  DEFAULT_APR_STATE,
} from "@silo/utils";

interface AprStateProps {
  aprState: AprStateType | null;
  utilizationState: UtilizationState;
}

export function AprState({
  utilizationState,
  aprState,
}: AprStateProps): JSX.Element {
  return (
    <KeyValueList.Pair
      description={
        <div
          className={cn(
            "flex flex-col gap-2.5",
            getUtilizationClassName(utilizationState)
          )}
        >
          <p>
            {getAprDescription(aprState ?? DEFAULT_APR_STATE)} View charts for
            historical rates.
          </p>

          <DescriptionExternalLink href={LINKS.SILOPEDIA.APR_STATES} />
        </div>
      }
      forceStaticDescription={utilizationState === "critical"}
    >
      <KeyValueList.Key>APR state</KeyValueList.Key>

      <KeyValueList.Value className={getUtilizationClassName(utilizationState)}>
        {getAprLabel(aprState)}
      </KeyValueList.Value>
    </KeyValueList.Pair>
  );
}
